export default [
  'createCompany',
  'createDeal',
  'createEvent',
  'createMilestone',
  'createPerson',
  'createProject',
  'createTask',
  'editCompany',
  'editDeal',
  'editEvent',
  'editMilestone',
  'editPerson',
  'editProject',
  'editTask'
]
